import { Component, OnInit } from '@angular/core';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';
import { JsonConfiguration } from './json';
@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss'],
  providers: [JsonConfiguration],
})
export class ContractsComponent implements OnInit {
  titleData: Title = this.jsonConfiguration.titleData;
  headerConfiguration: HeaderConfiguration =
    this.jsonConfiguration.headerConfiguration;

  constructor(private jsonConfiguration: JsonConfiguration) {}

  ngOnInit(): void {}
}
